<template>
  <section id="adoption">
    <div class="section-container">
      <div class="a-header-container">
        <div class="page-label">
          Adoption
        </div>
        <SelectedPartner />
      </div>
      <UnitHero />
      <div class="body-container">
        <div class="flex-column-2">
          <TechnicianBoard />
          <VerificationPieChart />
        </div>
        <div class="flex-column-2">
          <NumberHero />
          <CumulativeChart />
          <PlanBoard />
          <InstallationChart />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import adminMixin from '@shared/mixins/adminMixin';
import adoptionMixin from '@shared/mixins/adoptionMixin';
import UnitHero from '@shared/components/adoption/UnitHero.vue';
import TechnicianBoard from '@shared/components/adoption/TechnicianBoard.vue';
import NumberHero from '@shared/components/adoption/NumberHero.vue';
import CumulativeChart from '@shared/components/adoption/CumulativeChart.vue';
import PlanBoard from '@shared/components/adoption/PlanBoard.vue';
import InstallationChart from '@shared/components/adoption/InstallationChart.vue';
import VerificationPieChart from '@shared/components/adoption/VerificationPieChart.vue';
import SelectedPartner from '@shared/components/admin/SelectedPartner.vue';

export default {
  name: 'AdoptionView',
  metaInfo: {
    title: 'SmartAC.com | Adoption',
  },
  components: {
    SelectedPartner,
    UnitHero,
    TechnicianBoard,
    NumberHero,
    CumulativeChart,
    PlanBoard,
    InstallationChart,
    VerificationPieChart,
  },
  mixins: [adminMixin, adoptionMixin],
  data() {
    return {
      loading: false,
    };
  },
  watch: {
    selectedCorpId() {
      this.initialLoad();
    },
  },
  async mounted() {
    this.initialLoad();
  },
  methods: {
    async initialLoad() {
      this.$store.dispatch('resetInstallFilters');
      await this.$store.dispatch('getTechnicians');
    },
    handleChange(field, value) {
      this.$store.dispatch('changeAdoptionValues', [{
        field,
        value,
      }]);
    },
  },
};
</script>

<style lang="scss" scoped>

section#adoption {
  display: flex;
  flex: 1;
  background: $BLACK;
  letter-spacing: 0.2px;
  justify-content: center;
  padding: 52px 100px 0;
  @media (max-width: 1279px) {
    padding: 52px 60px 0;
  }
  @media (max-width: 1023px) {
    padding: 52px 40px 0;
  }
  .section-container {
    display: grid;
    gap: 24px;
    align-content: flex-start;
    grid-template-rows: auto auto auto 1fr;
    width: 1300px;
    @media (max-width: 1280px) {
      width: 100%;
      font-size: 90%;
      gap: 12px;
    }
    @media (max-width: 1023px) {
      font-size: 80%
    }
    @media (max-width: 850px)  {
      font-size: 70%;
    }
    .a-header-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .a-partner-filter {
      display: flex;
      flex-direction: column;
    }
    .body-container {
      display: flex;
      align-items: flex-start;
    }
  }
}
</style>
